export default {"src":"/_next/static/media/admin-services.cde8499f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};